"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.container = exports.v4Dependencies = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
Object.defineProperty(exports, "container", { enumerable: true, get: function () { return event_tracking_core_1.container; } });
var types_1 = require("./types");
var reporter_1 = require("./reporter");
var services_1 = require("./services");
var gateway_1 = require("./gateway");
var ClickEventObserver_1 = require("./services/ClickEventObserver");
var InputEventObserver_1 = require("./services/InputEventObserver");
var UnloadEventObserver_1 = require("./services/UnloadEventObserver");
var VisibilityEventObserver_1 = require("./services/VisibilityEventObserver");
var LogDataStore_1 = require("./services/LogDataStore");
var TimeProcessorTask_1 = require("./services/TimeProcessorTask");
var UploadTimerService_1 = require("./services/UploadTimerService");
var WebCleanUploadLogs_1 = require("./services/WebCleanUploadLogs");
var UploadTask_1 = require("./services/UploadTask");
var AfterUploadTask_1 = require("./services/AfterUploadTask");
var QueryLogsTask_1 = require("./services/QueryLogsTask");
var SaveLogsTask_1 = require("./services/SaveLogsTask");
var SDKConfigService_1 = require("./services/SDKConfigService");
var SaveLogsService_1 = require("./services/SaveLogsService");
var NativeUploadLogsService_1 = require("./services/NativeUploadLogsService");
var WebClickService_1 = require("./services/WebClickService");
var NativeClickService_1 = require("./services/NativeClickService");
var BeforeSaveTask_1 = require("./services/BeforeSaveTask");
var NativeCleanUploadLogs_1 = require("./services/NativeCleanUploadLogs");
var MarkLogsUploadable_1 = require("./services/MarkLogsUploadable");
var ExposeService_1 = require("./services/ExposeService");
var StatisticsService_1 = require("./services/StatisticsService");
var LeaveOpsService_1 = require("./services/LeaveOpsService");
var RemoveLogsService_1 = require("./services/RemoveLogsService");
var WebInputService_1 = require("./services/WebInputService");
var NativeInputService_1 = require("./services/NativeInputService");
var NativeUploadSavedService_1 = require("./services/NativeUploadSavedService");
var ExposeDataManager_1 = require("./services/ExposeDataManager");
var PrintLogService_1 = require("./services/PrintLogService");
var ExposeEventObserver_1 = require("./services/ExposeEventObserver");
exports.v4Dependencies = new inversify_1.ContainerModule(function (bind) {
    bind(types_1.TYPES.V4ReportService).to(reporter_1.Reporter).inRequestScope();
});
event_tracking_core_1.container
    .bind(types_1.TYPES.ILogService)
    .to(services_1.NativeUploadTask)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.NativeUploadTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IReportService)
    .to(gateway_1.WebGateway)
    .inRequestScope()
    .whenTargetNamed(types_1.TAG.WebGateway);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IReportService)
    .to(gateway_1.NativeGateway)
    .inRequestScope()
    .whenTargetNamed(types_1.TAG.NativeGateway);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(ClickEventObserver_1.ClickEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.ClickEventObserver);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(InputEventObserver_1.InputEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.InputEventObserver);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(UnloadEventObserver_1.UnloadEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.UnloadEventObserver);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(VisibilityEventObserver_1.VisibilityEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.VisibilityEventObserver);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(BeforeSaveTask_1.BeforeSaveTask)
    .whenTargetNamed(types_1.TAG.BeforeSaveTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(TimeProcessorTask_1.TimeProcessorTask)
    .whenTargetNamed(types_1.TAG.TimeProcessorTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(SaveLogsTask_1.SaveLogsTask)
    .whenTargetNamed(types_1.TAG.SaveLogsTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(QueryLogsTask_1.QueryLogsTask)
    .whenTargetNamed(types_1.TAG.QueryLogsTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(MarkLogsUploadable_1.MarkLogsUploadable)
    .whenTargetNamed(types_1.TAG.MarkLogsUploadable);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(WebCleanUploadLogs_1.WebCleanUploadLogs)
    .whenTargetNamed(types_1.TAG.WebCleanUploadLogs);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(NativeCleanUploadLogs_1.NativeCleanUploadLogs)
    .whenTargetNamed(types_1.TAG.NativeCleanUploadLogs);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(UploadTask_1.UploadTask)
    .whenTargetNamed(types_1.TAG.WebUploadTask);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IPipelineTask)
    .to(AfterUploadTask_1.AfterUploadTask)
    .whenTargetNamed(types_1.TAG.AfterUploadTask);
event_tracking_core_1.container.bind(types_1.TYPES.ILogDataStore).to(LogDataStore_1.LogDataStore).inSingletonScope();
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IConfigService)
    .to(SDKConfigService_1.SDKConfigService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.SDKConfigService);
// 存储数据流程
event_tracking_core_1.container
    .bind(types_1.TYPES.IDispatchLogsService)
    .to(SaveLogsService_1.SaveLogsService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.SaveLogsService);
// 上报到客户端流程
event_tracking_core_1.container
    .bind(types_1.TYPES.IDispatchLogsService)
    .to(NativeUploadLogsService_1.NativeUploadLogsService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.NativeUploadLogsService);
// 上报存储的数据到客户端流程（input, expose）
event_tracking_core_1.container
    .bind(types_1.TYPES.IDispatchLogsService)
    .to(NativeUploadSavedService_1.NativeUploadSavedService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.NativeUploadSavedService);
// web 定时上报流程
event_tracking_core_1.container
    .bind(types_1.TYPES.IUploadTimerService)
    .to(UploadTimerService_1.UploadTimerService)
    .inSingletonScope();
// 更新数据流程
event_tracking_core_1.container
    .bind(types_1.TYPES.IClickService)
    .to(WebClickService_1.WebClickService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.WebClickService);
event_tracking_core_1.container
    .bind(types_1.TYPES.IClickService)
    .to(NativeClickService_1.NativeClickService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.NativeClickService);
event_tracking_core_1.container.bind(types_1.TYPES.IExposeService).to(ExposeService_1.ExposeService).inSingletonScope();
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IEventOrderBucket)
    .to(event_tracking_core_1.EventOrderBucket)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.EventOrderBucket);
event_tracking_core_1.container.bind(types_1.TYPES.IStatisticsService).to(StatisticsService_1.StatisticsService);
event_tracking_core_1.container.bind(types_1.TYPES.ILeaveOpsService).to(LeaveOpsService_1.LeaveOpsService);
event_tracking_core_1.container.bind(types_1.TYPES.IRemoveLogsService).to(RemoveLogsService_1.RemoveLogsService);
event_tracking_core_1.container
    .bind(types_1.TYPES.IInputService)
    .to(WebInputService_1.WebInputService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.WebInputService);
event_tracking_core_1.container
    .bind(types_1.TYPES.IInputService)
    .to(NativeInputService_1.NativeInputService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.NativeInputService);
event_tracking_core_1.container
    .bind(types_1.TYPES.IExposeDataManager)
    .to(ExposeDataManager_1.ExposeDataManager)
    .inSingletonScope();
event_tracking_core_1.container.bind(types_1.TYPES.IPrintLogService).to(PrintLogService_1.PrintLogService).inSingletonScope();
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IStoreService)
    .to(event_tracking_core_1.LocalStoreService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.LocalStoreService);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IStoreService)
    .to(event_tracking_core_1.SessionStoreService)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.SessionStoreService);
event_tracking_core_1.container
    .bind(event_tracking_core_1.TYPES.IObserver)
    .to(ExposeEventObserver_1.ExposeEventObserver)
    .inSingletonScope()
    .whenTargetNamed(types_1.TAG.ExposeEventObserver);
